import React, {useEffect} from "react";
import { animations, easings, HideUntilLoaded } from "react-animation";
import { NavLink } from "react-router-dom";
import Image from "../../../assets/images/platforms/adashi/image.png";

const Adashi = () => {
const anim1 = {
  animation: `pop-in ${easings.linear} 1000ms forwards`,
};
const anim2 = {
  animation: `pop-in ${easings.easeInOutQuad} 1000ms forwards`,
};

useEffect(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  return () => {};
}, []);

  return (
    <div className="" style={{ marginTop: "-80px" }}>
      <div className="container">
        <div className="">
          <div className="platform-page-container">
            <div className="platform-page-inner">
              <div className="container">
                {" "}
                <img src={Image} alt="" className="p-image" />
              </div>{" "}
              <div className="">
                <p>
                  You can buy valuable things like Phones, Laptops, Home
                  appliances, vehicle, and many more out of their salary.
                </p>
              </div>
              <div className="signup-btn-primary">
                <NavLink to="/sign-up">
                  <button className="primary-btn">Get Started</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adashi;
